import Button from '@sats-group/ui-lib/react/button';
import Link from '@sats-group/ui-lib/react/link';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import BackgroundImage from '../background-image/background-image';
import ContentContainer from '../content-container/content-container';
import type { BootCampEventHero as Props } from './boot-camp-event-hero.types';

const BootCampEventHero = React.forwardRef<HTMLDivElement, Props>(
  (
    { brand, image, info, nonMemberPriceInfo, signUpUrl, termsUrl, title },
    ref
  ) => (
    <div className="boot-camp-event-hero">
      <ContentContainer theme={ContentContainer.themes.wide} raw>
        <div className="boot-camp-event-hero__inner">
          <div
            className={`boot-camp-event-hero__details boot-camp-event-hero__details--${brand}`}
          >
            <Text
              elementName="h1"
              size={Text.sizes.headline1}
              theme={Text.themes.headline}
              italic
            >
              {title}
            </Text>

            <div className="boot-camp-event-hero__info">
              {info.map(item => (
                <div
                  key={item.value}
                  className="boot-camp-event-hero__info-item"
                >
                  <Text
                    elementName="span"
                    className="boot-camp-event-hero__info-label"
                  >
                    {item.text}
                  </Text>
                  <Text elementName="span" theme={Text.themes.emphasis}>
                    {item.value}
                  </Text>
                </div>
              ))}
            </div>

            <div>
              <div ref={ref}>
                <LinkButton
                  variant={Button.variants.cta}
                  {...signUpUrl}
                  className="boot-camp-event-hero__action"
                />
              </div>

              <div className="boot-camp-event-hero__footnote">
                <Text
                  size={Text.sizes.small}
                  className="boot-camp-event-hero__non-member-info"
                  elementName="p"
                >
                  {nonMemberPriceInfo}
                </Text>
                <div className="boot-camp-event-hero__terms">
                  <Link variant={Link.variants.orange} {...termsUrl} />
                </div>
              </div>
            </div>
          </div>

          {image ? (
            <div className="boot-camp-event-hero__image">
              <BackgroundImage {...image} />
            </div>
          ) : null}
        </div>
      </ContentContainer>
    </div>
  )
);

export default BootCampEventHero;
